import Slider from "react-slick";
import { Box, makeStyles } from "@material-ui/core";

import { QuoteLineItem } from "../../../../api/Quote/QuoteLineItem";
import { sliderSettings } from "../../../../components/Slider";

export const QuoteInfoSlider = ({ lineItems }: Props) => {
  const classes = useStyles();

  if (lineItems === null) {
    return null;
  }

  const slideRender = function (item: QuoteLineItem) {
    if (item === null || item.imageUrl === null) {
      return null;
    }

    return (
      <Box
        key={item.productId}
        width={"100%"}
        height={"100%"}
        display={"flex !important"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <img alt={item.name} src={item.imageUrl} />
      </Box>
    );
  };

  return (
    <Box width={"100%"} height={"100%"}>
      <Slider {...sliderSettings} autoplay={true} autoplaySpeed={8000} className={classes.imageSlider}>
        {lineItems.map((li) => slideRender(li))}
      </Slider>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  imageSlider: {
    "height": "100%",
    "& .slick-list": {
      "height": "100%",
      "& .slick-track": {
        height: "100%"
      }
    },
    "& .slick-dots li": {
      margin: 0
    },
    "& .slick-dots li button": {
      [theme.breakpoints.down("sm")]: {
        width: "10px",
        height: "10px"
      }
    },
    "& .slick-dots li button:before": {
      fontSize: "10px",
      color: "#f7815c",
      [theme.breakpoints.down("sm")]: {
        fontSize: "7px",
        width: "10px",
        height: "10px"
      }
    },
    "& .slick-dots .slick-active button:before": {
      opacity: 1
    },
    "& .slick-slide div": {
      height: "100%"
    },
    "& .slick-slide img": {
      maxHeight: "321px",
      maxWidth: "300px",
      objetFit: "cover",
      outline: "transparent",
      [theme.breakpoints.down("md")]: {
        maxHeight: "320px",
        maxWidth: "220px"
      }
    },
    "& .slick-slide .MuiBox-root": {
      outline: "transparent"
    },
    "& .slick-next, & .slick-prev": {
      display: "none !important"
    },
    "& .slick-dots": {
      bottom: "20px",
      [theme.breakpoints.down("sm")]: {
        bottom: "0px"
      }
    }
  }
}));

interface Props {
  lineItems: QuoteLineItem[] | null;
}
